import SelectCustom from '@design/objects/form/select-custom/twig/assets'
import setEvents from '@design/objects/form/shared/field/assets/setEvents'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import type { SelectCustomConfig } from '@design/objects/select-custom/twig/assets'

export type { default as SelectCustom, SelectCustomConfig } from '@design/objects/select-custom/twig/assets'

export default (element: HTMLDetailsElement, config: SelectCustomConfig = {}): ReturnType<typeof SelectCustom> => {
  const selectEl = element.querySelector<HTMLSelectElement>('select')

  if (!selectEl || ElementPropertiesManager.hasProperty(selectEl, 'select')) {
    return
  }

  const selectCustom = SelectCustom(element, config)

  if (selectCustom) {
    setEvents(selectEl)
    ElementPropertiesManager.addProperty<typeof selectCustom>(selectEl, 'select', selectCustom)

    const applyButtonText = selectEl.getAttribute('data-apply-button')

    if (applyButtonText && selectEl.multiple) {
      const listbox = element.querySelector('ul[role="listbox"]')

      if (listbox) {
        const applyButton = document.createElement('button')
        applyButton.type = 'button'
        applyButton.className = 'dca-button dca-button--secondary-outline o-select-custom__apply'
        applyButton.textContent = applyButtonText
        applyButton.addEventListener('click', () => {
          selectCustom.close()
        })
        listbox.insertAdjacentElement('afterend', applyButton)
      }
    }
  }

  return selectCustom
}
